// import {Inject} from 'prism-web'
// import {PlotNoSqlService} from '../service/PlotNoSqlService';
import Util from './PlotUtil';
export class PlotManagerMapComponent extends window.G.base.ComponentBase {
    // @Inject(PlotNoSqlService) mapservices;
    // tslint:disable-next-line: member-ordering
    public opt: any;
    // tslint:disable-next-line: member-ordering
    public options: any;
    // tslint:disable-next-line: member-ordering
    public PlotComponent: any;
    // tslint:disable-next-line: member-ordering
    public plotLayer: any;
    // tslint:disable-next-line: variable-name
    public _isWhiteBoard: any;
    public userid: any;
    public noSave: any;
    public plotMap: any;
    public plotUtil: any;
    public mapservices: any;
    public plotListjson: any;
    public plotIconsBase64: any;

    constructor(opt: any) {
        super(opt);
        this.opt = opt;
    }

    public initialize(opts: any) {
        this.options = opts;
        this.options.spatialReference = this.options.map.spatialReference;
        this.options.PlotServiceUrl = null; // sql标绘服务
        this.options.PlotConfigService = null;
        this.options.PlotNoSqlService = null;
        this.options.textBorder = {
            borderColor: {
                alpha: 1,
                r: 255,
                g: 255,
                b: 255,
            },
            borderThickness: 0,
        };
    }

    // 添加Control
    public addControl() {
        // 创建标绘组件
        this.PlotComponent = new window.G.plot.PlotComponent({
            map: this.options.map,
            layerId: 'plot-layer',
        });
        this.PlotComponent.enableEdit(true);
        this.plotLayer = this.PlotComponent.getLayer();
        // 标绘工具
        // this.plotUtil = this.options.PlotManagerUtil.getCacheInstance(this.options.map.namespace);
        // 是否是白板标绘
        this._isWhiteBoard = false;
        // 用户id模拟的用户
        this.userid = '2f2ee16f-44ac-c7ed-c8ba-52ec60a1a1fe';
        this._initService();
        // 创建地图监听
        this.PlotComponent.on(window.G.misc.AppEvents.PLOT_CLICKED, this._plotClickListener, this);
        // 未保存的标绘变量
        this.noSave = {
            data: [],
        };
        this.plotMap = {};
        // 标绘完成
        this.PlotComponent.on(window.G.misc.AppEvents.PLOT_CREATED, this._plotCompleteListener, this);
        this.PlotComponent.on('openTailedLabelEdit', this._openTailedLabelEdit, this);
        // 监听清屏
        this.options.map.listen(window.G.misc.AppEvents.CLEAR_MAP, this.cleanScreenCallBack, this);
    }

    public destroy() {
        this.PlotComponent.off(window.G.misc.AppEvents.PLOT_CREATED, this);
        this.options.map.off(window.G.misc.AppEvents.CLEAR_MAP, this);
        this.PlotComponent.off(window.G.misc.AppEvents.PLOT_CLICKED, this);
        this.plotUtil.reset();
        // PureComponent.prototype.destroy.call(this);

        this.PlotComponent.options.tailedLabelComponent.onClose();
    }
    public setIcons(icons: any) {
        this.plotIconsBase64 = icons;
    }

    public setService(service: any) {
        this.mapservices = service;
        // console.log(this.mapservices);

    }

    // 初始化服务
    public _initService() {

        // console.log(this.mapservices);
        // let deserializer = new window.g2.core.Deserializer();
        // let ajaxhttp = new window.g2.core.RestHttp({token: 'Bearer d277145'});
        // let createPlotService = {
        //     'SQL': function (options) {
        //         options.plotService = new window.g2.plot.RestPlotService({
        //             url: options.PlotServiceUrl,
        //             deserializer: deserializer,
        //             http: ajaxhttp
        //         });
        //     },
        //     'NOSQL': function (options) {
        //         options.plotService = this.options.PlotNoSqlService;
        //     }
        // };
        // createPlotService[this.options.RestPlotService](this.options);
    }


    // 开启绘制
    public startPlot() {
        return false;
    }

    /**
     * 接收绘制应急标绘事件
     * @param opts
     * @param opts.code: "PT110101"
     * @param opts.desc: "洪水、内涝、水库险情、堤防险情、凌汛灾害、山洪、农业干旱、城镇缺水、生态干旱、饮水困难等"
     * @param opts.name {String} 绘制符号名称类型 "水旱灾害"
     * @param opts.symbol {String} svg符号地址 "自然灾害/水旱灾害.svg"
     */
    public emergencyPlot(opts: any) {
        const t = opts.symbol.split('.')[0].split('/');
        const name = t[t.length - 1];
        const opt = {
            icons: this.plotIconsBase64[name],
            name: opts.name,
            tit: opts.code,
            type: 'Point',
            key: 'point',
        };
        this.draw(opt);
    }

    /**
     * 绘制标绘
     * @method
     * @param opts {Object} - 必填
     * @param opts.type {String} - 必填，标绘的类型，G.plot.TYPES下的枚举值;
     * @param opts.base {String} - 可选，base64;
     * @param opts.width {String} - 可选，宽度;
     * @param opts.height {String} - 可选，height;
     * @param opts.callback {Function} - 可选，绘制完成的回调，回调参数为当前标绘的元素;
     * @param opts.context {Object} - 可选，绘制完成的回调上下文;
     */
    public draw(opts: any) {
        const self: any = this;
        const paramObj: any = {};
        paramObj.callback = opts.callback;
        paramObj.context = opts.context;

        if (opts.type === window.G.plot.TYPES.Point) {
            paramObj.type = opts.type;
            if (opts.base64) {
                // 标绘的符号
                paramObj.symbol = {
                    type: 'PictureMarkerSymbol',
                    options: {
                        source: 'data:image/png;base64,' + opts.base64,
                        width: opts.width || 42,
                        height: opts.height || 42,
                        offsetX: 0,
                        offsetY: 0,
                        opacity: 1,
                    },
                };
                self.PlotComponent.plot(paramObj);
            } else {
                paramObj.symbol = {
                    type: 'VectorMarkerSymbol',
                    options: {
                        source: opts.icons,
                        width: 30,
                        height: 30,
                        offsetX: 0.5,
                        offsetY: 0.5,
                        scale: 1,
                        opacity: 1,
                        rotation: 0,
                    },
                };
                self.PlotComponent.plot(paramObj);
            }
        } else if (opts.type === window.G.plot.TYPES.Text) {
            paramObj.type = opts.type;
            if (opts.symbol) {
                paramObj.symbol = opts.symbol;
                paramObj.text = opts.symbol.options.text.toString();
                paramObj.symbol.options.borderColor = self.options.textBorder.borderColor;
                paramObj.symbol.options.borderThickness = self.options.textBorder.borderThickness;
            } else {
                paramObj.text = '自定义文本';
            }
            paramObj.text = Util.addTextLineSeperator(paramObj.text, this.opt.textLineLimit);
            self.PlotComponent.plot(paramObj);
        } else if (opts.type === window.G.plot.TYPES.TAILEDTEXT) {
            paramObj.type = opts.type;
            paramObj.text = '自定义文本';
            paramObj.text = Util.addTextLineSeperator(paramObj.text, this.opt.textLineLimit);
            paramObj.tailedtext_symbol = opts.tailedtext_symbol;
            self.PlotComponent.plot(paramObj);
        } else {
            paramObj.type = opts.type;
            paramObj.size = opts.size;
            paramObj.symbol = opts.symbol;
            self.PlotComponent.plot(paramObj);
        }
    }


    /**
     * 标绘元素点击回调
     * @method
     */
    public _plotClickListener(event: any) {
        const plotElement: any = event.element;
        if (plotElement != null) {
            if (this._plotEffective(plotElement)) {
                // 获取点击元素
                let descStr: any = '';
                const symbolHex: any = {};
                const isTailedLabel = this.isTailedLabel(plotElement);
                if (isTailedLabel) {
                    if (plotElement.attributeSet.attributes.length > 0) {
                        descStr = plotElement.attributeSet.getItem(0).value;
                    }
                    // const tailedLabelAttr: any = JSON.parse(plotElement.tailedLabelAttr);
                    symbolHex.type = 'TailedText';
                    symbolHex.inputFont = plotElement.label;
                    symbolHex.linewidth = plotElement.lineWidth;
                    symbolHex.lineColor = this._color2Hex(plotElement.lineColor);
                    symbolHex.borderWidth = plotElement.textBackgroundBorderThickness;
                    symbolHex.borderColor = this._color2Hex(plotElement.textBackgroundBorderColor);
                    symbolHex.fontFamilyLi = plotElement.fontFamilyName;
                    symbolHex.fontSizeLi = plotElement.fontSize;
                    symbolHex.fillColor = this._color2Hex(plotElement.backgroundColor);
                    symbolHex.textColor = this._color2Hex(plotElement.foregroundColor);
                    symbolHex.foregroundColor = this._color2Hex(plotElement.foregroundColor);
                    symbolHex.iconOpacity = plotElement.foregroundColor.a;
                    symbolHex.inputDesc = descStr;
                    this.firePlotClickEvent({
                        id: plotElement.id,
                        // schemaId,
                        // businessId,
                        symbol: symbolHex,
                        plotProperty: descStr,
                    });
                } else {
                    const element: any = plotElement.elements[0];
                    if (element.attributeSet.attributes.length > 0) {
                        descStr = element.attributeSet.getItem(0).value;
                    }
                    const symbol: any = element.symbol;
                    const obj: any = window.G.utils.RenderUtil.symbol2Object(symbol);
                    const type: any = obj.type;
                    if (type === 'SimpleFillSymbol') {
                        const borderColor = obj.options.borderColor;
                        const borderThickness = obj.options.borderThickness;
                        const opacity = obj.options.opacity;
                        const fillColor = obj.options.fillColor;
                        const style = obj.options.style;
                        symbolHex.type = type;
                        symbolHex.borderColor = this._color2Hex(borderColor);
                        symbolHex.linewidth = borderThickness;
                        symbolHex.fillColor = this._color2Hex(fillColor);
                        symbolHex.lineStyle = style.toString();
                        symbolHex.iconOpacity = borderColor.a;
                        symbolHex.inputDesc = descStr;
                    } else if (type === 'SimpleLineSymbol') {
                        const color = obj.options.color;
                        const width = obj.options.width;
                        const style = obj.options.style;
                        symbolHex.type = type;
                        symbolHex.borderColor = this._color2Hex(color);
                        symbolHex.linewidth = width;
                        symbolHex.lineStyle = style.toString();
                        symbolHex.iconOpacity = color.a;
                        symbolHex.inputDesc = descStr;
                    } else if (type === 'TextSymbol') {
                        const fontFamilyName = obj.options.fontFamilyName;
                        const text = obj.options.text.toString();
                        const fontSize = obj.options.fontSize;
                        const foreground = obj.options.foreground;
                        symbolHex.fontFamilyLi = fontFamilyName;
                        symbolHex.type = type;
                        symbolHex.inputFont = text;
                        symbolHex.fontSizeLi = fontSize;
                        symbolHex.textColor = this._color2Hex(foreground);
                        symbolHex.inputDesc = descStr;
                    } else if (type === 'SimpleMarkerSymbol') {
                        if (plotElement.kind === 'tailedtext') {
                            // const tailedLabelAttr: any = JSON.parse(plotElement.tailedLabelAttr);
                            // symbolHex.type = 'TailedText';
                            // symbolHex.inputFont = tailedLabelAttr.domHtml;
                            // symbolHex.linewidth = tailedLabelAttr.symbol.options.width;
                            // const lineColorTem = tailedLabelAttr.symbol.options.color;
                            // symbolHex.lineColor = this._color2Hex(lineColorTem);
                            // symbolHex.borderWidth = parseInt(tailedLabelAttr.domStyle.border.split('px')[0], 10);
                            // symbolHex.borderColor = '#' + tailedLabelAttr.domStyle.border.split('#')[1];
                            // symbolHex.fontFamilyLi = tailedLabelAttr.domStyle.fontFamily;
                            // symbolHex.fontSizeLi = parseInt(tailedLabelAttr.domStyle['font-size'].split('px'), 10);
                            // symbolHex.fillColor = tailedLabelAttr.domStyle.background;
                            // symbolHex.textColor = tailedLabelAttr.domStyle.color;
                            // symbolHex.iconOpacity = tailedLabelAttr.domStyle.opacity * 255;
                            // symbolHex.inputDesc = descStr;
                        }
                    } else if (type === 'PictureMarkerSymbol') {
                        this.fireClearEditPanelEvent();
                        // self.firePlotClickEvent({
                        //     id: plotElement.id
                        // });
                    } else if (type === 'VectorMarkerSymbol') {
                        symbolHex.options = obj.options;
                        symbolHex.scale = obj.options.scale;
                        symbolHex.iconOpacity = obj.options.opacity * 255;
                        symbolHex.inputDesc = descStr;
                        symbolHex.type = type;
                    }
                    if (type !== 'PictureMarkerSymbol') {
                        this.firePlotClickEvent({
                            id: plotElement.id,
                            symbol: symbolHex,
                            plotProperty: descStr,
                        });
                    }
                }

            }
        } else {
            this.fireClearEditPanelEvent();
        }
    }

    public _getAlgorithmType(element: any) {
        if (element) {
            if (element.algorithm) {
                return element.algorithm.$type;
            } else if (element.$type) {
                return element.$type;
            }
        }
    }

    /**
     * 判断元素是普通标绘还是引线标注
     * @param ele
     */
    public isTailedLabel(ele: any) {
        let flag = false;
        if (ele.$type && ele.$type.indexOf('LeadLabel') > -1) {
            flag = true;
        }
        return flag;
    }
    /**
     * 判断标绘是否有效
     * @method
     */
    public _plotEffective(element: any) {
        let exist = true;
        const plotAlgorithmTwo: any = ['PolygonAlgorithm', 'RectangleAlgorithm', 'DoubleArrowAlgorithm', 'SwallowTailArrowAlgorithm',
            'SimpleArrowAlgorithm', 'ArsenalAlgorithm', 'ExpertProtectAlgorithm', 'PowerRepairAlgorithm',
            'ArmyAlgorithm', 'FireProtectAlgorithm', 'MedicalCureAlgorithm', 'PowerRepairAlgorithm', 'ProChymicAlgorithm',
            'ProSuccorAlgorithm', 'CannonAlgorithm', 'ArtilleryManenCampmentAlgorithm'];
        const typeAlgorithm = this._getAlgorithmType(element);
        const controlPoints = element.plot ? element.plot.controlPoints : [];
        for (const index in plotAlgorithmTwo) {
            if (typeAlgorithm.indexOf(plotAlgorithmTwo[index]) > -1 && controlPoints.length < 3) {
                exist = false;
            }
        }
        return exist;
    }

    /**
     * 标绘完成处理方法
     * @method
     * @param data
     * @param data.type {String} - 必填，标绘类型
     * @param data.element {Object} - 必填，标绘元素
     */
    public _plotCompleteListener(data: any) {
        const self = this;

        if (self._plotEffective(data.element)) {
            // self.plotUtil.add(data.element);
            const opts = self.noSave.data;
            const plot: any = {};
            plot.id = data.element.id;
            plot.content = data.element.name;
            opts.push(plot);
            self.updateUnsavedView();
        }
    }

    public _openTailedLabelEdit(data: any) {
        this._plotClickListener({ element: data });
    }


    /**
     * 更新未保存的标绘
     * @method
     */
    public updateUnsavedView() {
        this.fire('updateUnsavedView', this.noSave);
    }

    /**
     * 清屏-清除未保存的标绘和地图上的标绘
     * @method
     * @param
     */
    public cleanScreenCallBack() {
        const plotArr = this.plotLayer.elements;
        for (let i = plotArr.length - 1; i >= 0; i--) {
            // this.plotUtil.remove(plotArr[i]);
            this.removeFromUnsaved(plotArr[i].id);
            this.PlotComponent.removePlotElement(plotArr[i].id);
        }
        this.updateUnsavedView();
        this.refreshPlotSchemaList();
    }

    /**
     * *****************************************************************************
     */
    /**
     * 删除未保存的标绘，地图上也清空
     * @method
     * @param id {String} - 必填，元素id
     */
    public removeUnsaved(id: any) {
        const self = this;
        self.removeFromUnsaved(id);
        self.PlotComponent.removePlotElement(id);
        //
        const plotArr = self.plotLayer.elements;

        // for ( let j = 0; j < plotArr.length; j++ ) {
        //     if (plotArr[j].id === id) {
        //         self.plotUtil.remove(plotArr[j]);
        //     }
        // }
        for (const obj of plotArr) {
            if (obj.id === id) {
                self.plotUtil.remove(obj);
            }
        }
    }

    /**
     * 从未保存的标绘缓存中移除
     * @method
     * @param id {String} - 必填，元素id
     */
    public removeFromUnsaved(id: any) {
        const data = this.noSave.data;
        for (let i = data.length - 1; i >= 0; i--) {
            if (data[i].id === id) {
                data.splice(i, 1);
                break;
            }
        }
    }

    /**
     * *****************************************************************************
     */
    /**
     * 刷新标绘方案列表
     * @method
     */
    public refreshPlotSchemaList() {
        const self = this;
        self.mapservices.list(self.userid, '1900-01-01 00:00:00', '2100-01-01 00:00:00').then((summaries: any) => {
            const data: any = [];
            // for (let i = 0; i < summaries.length; i++) {
            //     const plot: any = {};
            //     plot.id = summaries[i].id;
            //     plot.val = summaries[i].name;
            //     plot.createTime = summaries[i].createTime;
            //     data.push(plot)
            // }
            for (const obj of summaries) {
                const plot: any = {};
                plot.id = obj.id;
                plot.val = obj.name;
                plot.createTime = obj.createTime;
                data.push(plot);
            }

            data.sort(compare('createTime'));

            function compare(property: any) {
                return (obj1: any, obj2: any) => {
                    const value1 = obj1[property];
                    const value2 = obj2[property];
                    return value2 > value1 ? 1 : -1;
                };
            }

            const json: any = {};
            json.data = data;
            self.plotListjson = json;
            self.fireRefreshSchemaListEvent(json);

        }).catch((error: any) => {
            if (error.status === '404') {
                const json: any = {};
                json.data = [];
                self.plotListjson = json;
                self.fireRefreshSchemaListEvent(json);
            }
        });

        // self.mapservices.list(self.userid, '1900-01-01 00:00:00', '2100-01-01 00:00:00',
        //     function (summaries) {
        //         var data = [];
        //         for (var i = 0; i < summaries.length; i++) {
        //             var plot = {};
        //             plot.id = summaries[i].id;
        //             plot.val = summaries[i].name;
        //             plot.createTime = summaries[i].createTime;
        //             data.push(plot)
        //         }
        //         data.sort(compare('createTime'));
        //
        //         function compare(property) {
        //             return function (obj1, obj2) {
        //                 var value1 = obj1[property];
        //                 var value2 = obj2[property];
        //                 return value2 > value1 ? 1 : -1;
        //             }
        //         };
        //         var json = {};
        //         json.data = data;
        //         self.plotListjson = json;
        //         self.fireRefreshSchemaListEvent(json);
        //     },
        //     function (error) {
        //         if (error.status == '404') {
        //             var json = {};
        //             json.data = [];
        //             self.plotListjson = json;
        //             self.fireRefreshSchemaListEvent(json);
        //         }
        //         //G.utils.LoggerUtil.warn(error);
        //     });
    }

    /**
     * 白板标绘
     * @method
     * @param bool {Boolean} - 必填，是否白板标绘
     */
    public whiteBoardClick(bool: any) {
        const layers = this.options.map.layers;
        const visible = !(!!bool);
        this._isWhiteBoard = !visible;
        if (visible) {
            // for (let i = 0; i < layers.length; i++) {
            //     const layer = layers[i];
            //     if (layer) {
            //         if (layer._type === '_base_layer_tag' &&
            //             layer.hasOwnProperty('_used2beVisible')) {
            //             layer.setVisible(true);
            //             delete layer._used2beVisible;
            //         }
            //     }
            // }
            for (const obj of layers) {
                const layer = obj;
                if (layer) {
                    if (layer._type === '_base_layer_tag' &&
                        layer.hasOwnProperty('_used2beVisible')) {
                        layer.setVisible(true);
                        delete layer._used2beVisible;
                    }
                }
            }
        } else {
            // for (let i = 0; i < layers.length; i++) {
            //     const layer = layers[i];
            //     if (layer) {
            //         if (layer._type === '_base_layer_tag' &&
            //             layer.visible) {
            //             layer.setVisible(false);
            //             layer._used2beVisible = true;
            //             break;
            //         }
            //     }
            // }
            for (const obj of layers) {
                const layer = obj;
                if (layer) {
                    if (layer._type === '_base_layer_tag' &&
                        layer.visible) {
                        layer.setVisible(false);
                        layer._used2beVisible = true;
                        // break;
                    }
                }
            }
        }
    }

    /**
     * 保存标绘方案成功回调
     * @method
     * @param name {String} - 必填，方案名称
     */
    public savePlotSchema(name: any) {
        const self = this;
        const opts: any = {};
        opts.id = window.G.utils.CommonUtil.newUUID32();
        opts.name = name;
        opts.userId = self.userid;
        const schema = new (G as any).plot.PlotSchema(opts);
        // console.log(self.plotLayer);
        const count = self.plotLayer.getCount();
        for (let i = 0; i < count; ++i) {
            const ele = self.plotLayer.get(i);
            const cpy = ele.copy();
            cpy.unReset();
            cpy.id = ele.id;
            if (cpy.kind === 'tailedtext') {
                const tailedLabel = self.PlotComponent.options.tailedLabelComponent._getTailedLabel(ele.id);
                // tailedLabel._id = copy.id
                // tailedLabel.options.id = cpy.id
                cpy.tailedLabelAttr = tailedLabel.serialize();
            } else if (cpy.kind === 'point') {
                let index: any = 0;
                for (const subEle of cpy.elements) {
                    if (subEle.symbol instanceof g2.sfs.VectorMarkerSymbol) {
                        subEle.symbol.scale = ele.elements[index].symbol.scale;
                    }
                    index++;
                }
            }
            schema.addElement(cpy);
            // 移除未保存
            // self.removeFromUnsaved(ele.id);
        }

        //

        self.mapservices.save(schema).then((data: any) => {

            if (data.success) {
                window.G.utils.LoggerUtil.info('保存标绘成功!');
                self.planShowBack(schema.id);
                self.scanSchema(schema);
                for (let i = 0; i < count; ++i) {
                    const ele = self.plotLayer.get(i);
                    self.removeFromUnsaved(ele.id);
                }

                // 清空方案
                self.planCleanBack(schema.id);
                // 刷新列表
                self.refreshPlotSchemaList();

                self.updateUnsavedView();
                self.fire('schemaSaveSuccess');
            } else {

                window.G.utils.LoggerUtil.info('保存失败');
            }


        }).catch((error: any) => {

            let msg = '保存失败！';
            if (error) {
                const data = error.responseJSON;
                if (data) {
                    msg = data.message;
                    if (msg && msg.indexOf('SchemaNameIsExitError') >= 0) {
                        msg = '标绘方案名称不能重复！';
                    }
                }
            }
            window.G.utils.LoggerUtil.info(msg);
        });
    }

    /**
     * 调整视野状态参数更新
     * @method
     * @param schema {Object} - 必填，方案对象
     */
    public scanSchema(schema: any) {
        const self = this;
        const data: any = [];
        const plotArray: any = [];
        for (let i = 0; i < schema.getCount(); ++i) {
            const element = schema.getElement(i);
            const obj: any = {};
            obj.id = element.id;
            element.reset();
            data.push(obj);
            plotArray.push(element);
        }
        self.plotMap[schema.id] = data;
        // 调整视野
        const envlop = window.G.utils.GeometryUtil.getPlotEnvlop(plotArray, self.options.map.spatialReference);
        if (envlop) {
            if (envlop.$type.indexOf('Point') >= 0) {
                self.options.map.setCenter(envlop);
            } else {
                const offset = 100;
                self.options.map.pan(envlop, [offset, offset, offset, offset]);
            }
        }
    }

    /**
     * 显示方案
     * @method
     * @param schemaId {String} - 必填，方案id
     */
    public planShowBack(schemaId: any) {
        this.mapservices.load(schemaId).then((schema: any) => {
            const optSchema: any = {};
            optSchema.schema = schema;
            this.PlotComponent.loadPlotSchema(optSchema);
            this.scanSchema(schema);

        }).catch((error: any) => {
            window.G.utils.LoggerUtil.info('加载失败！');
        });
    }

    /**
     * 方案列表关键字搜索的回调
     * @method
     * @param name {String} - 必填，方案名称关键字
     */
    public planSearchBack(name: any) {
        const self = this;
        if (self.plotListjson.data) {
            const oldData = self.plotListjson.data;
            const newData: any = [];
            // for(let i = 0; i < oldData.length; i++) {
            //     if(oldData[i].val.indexOf(name) !== -1) {
            //         newData.push(oldData[i]);
            //     }
            // }
            for (const obj of oldData) {
                if (obj.val.indexOf(name) !== -1) {
                    newData.push(obj);
                }
            }
            const json: any = {};
            json.data = newData;
            self.firePlanSearchBackEvent(json);
        }
    }

    /**
     * 地图上清除方案
     * @method
     * @param schemaId {String} - 必填，方案id
     */
    public planCleanBack(schemaId: any) {
        const self = this;
        const data = self.plotMap[schemaId];
        if (window.G.utils.CommonUtil.isArray(data)) {
            // for(let i = 0; i < data.length; i++) {
            //     const eleId = data[i].id;
            //     self.PlotComponent.removePlotElement(eleId);
            // }
            for (const obj of data) {
                const eleId = obj.id;
                self.PlotComponent.removePlotElement(eleId);
            }
        }
        delete self.plotMap[schemaId];
    }

    /**
     * 更新方案
     * @param opts
     * @param opts.id
     * @param opts.schemaName
     */
    public updateSchema(opts: any) {
        const self = this;
        const options: any = {};
        options.id = opts.id;
        options.name = opts.schemaName;
        options.userId = self.userid;
        const schema = new (G as any).plot.PlotSchema(options);
        // console.log(self.plotLayer);
        const count = self.plotLayer.getCount();
        for (let i = 0; i < count; ++i) {
            const ele = self.plotLayer.get(i);
            const cpy = ele.copy();
            cpy.unReset();
            cpy.id = ele.id;
            if (cpy.kind === 'tailedtext') {
                const tailedLabel = self.PlotComponent.options.tailedLabelComponent._getTailedLabel(ele.id);
                cpy.tailedLabelAttr = tailedLabel.serialize();
            }
            schema.addElement(cpy);
        }

        self.mapservices.edit(schema).then((data: any) => {
            if (data) {
                window.G.utils.LoggerUtil.info('保存标绘成功!');
                self.planShowBack(schema.id);
                self.scanSchema(schema);
                for (let i = 0; i < count; ++i) {
                    const ele = self.plotLayer.get(i);
                    self.removeFromUnsaved(ele.id);
                }
                // 清空方案
                self.planCleanBack(schema.id);
                // 刷新列表
                self.refreshPlotSchemaList();

                self.updateUnsavedView();
                self.fire('schemaSaveSuccess');
            } else {
                window.G.utils.LoggerUtil.info('保存失败');
            }
        }).catch((error: any) => {
            let msg = '保存失败！';
            if (error) {
                const data = error.responseJSON;
                if (data) {
                    msg = data.message;
                    if (msg && msg.indexOf('SchemaNameIsExitError') >= 0) {
                        msg = '标绘方案名称不能重复！';
                    }
                }
            }
            window.G.utils.LoggerUtil.info(msg);
        });
    }

    /**
     * 方案列表删除方案
     * @method
     * @param schemaId {String} - 必填，方案id
     */
    public planDeleteBack(schemaId: any) {
        const self = this;
        self.mapservices.delete(schemaId).then((d: any) => {
            // 清除该方案的标绘
            self.planCleanBack(schemaId);
            window.G.utils.LoggerUtil.info('删除成功!');
            self.refreshPlotSchemaList();

        }).catch((error: any) => {
            window.G.utils.LoggerUtil.info('删除失败!');
        });
    }

    // /**
    //  * 更新标绘方案列表
    //  * @method
    //  */
    // updataPlotSchemaList(){
    //
    // }
    /**
     * 点击方案时加载标绘列表
     * @method
     * @param id {String} - 必填，方案id
     */
    public planEleListBack(id: any) {
        const self = this;
        self.mapservices.load(id).then((schema: any) => {
            const list: any = [];
            const eles = schema.elements;
            for (let k = 0, len = eles.length; k < len; k++) {
                const ele: any = eles[k];
                list.push({
                    id: ele.id,
                    name: ele.name || 'freePlot',
                });
            }
            const json: any = {};
            json.data = list;
            json.schema = schema;
            //
            self.firePlanEleListEvent(json);

        }).catch((error: any) => {
            window.G.utils.LoggerUtil.warn(error);
        });

    }

    public queryUserPlotSchema() {
        return false;
    }

    /**
     * *****************************************************************************
     */
    /**
     * 更新标绘
     * @method
     * @param data
     */
    public plotElementUpdate(opts: any) {
        const self = this;
        const plotId = opts.id;
        if (plotId) {
            //
            // const element = this.PlotComponent.getPlotElementById(plotId);
            // this.plotUtil.update(element);
            const descStr: any = opts.symbol.inputDesc || '';
            //
            const symbol = opts.symbol;
            const type = symbol.type;
            let symbolColor: any = {};
            if (type === 'SimpleFillSymbol') {
                const option: any = {};
                symbolColor.type = type;
                option.borderThickness = symbol.linewidth;
                const borderColorTem = this._hex2ColorObj(symbol.borderColor);
                // borderColorTem.a = parseInt(symbol.iconOpacity, 10);
                borderColorTem.a = parseInt(symbol.borderOpacity, 10);

                const fillColorTem = this._hex2ColorObj(symbol.fillColor);
                // fillColorTem.a = parseInt(symbol.iconOpacity, 10);
                fillColorTem.a = parseInt(symbol.fillOpacity, 10);

                option.borderColor = window.G.utils.RenderUtil.color2Object(borderColorTem);
                option.fillColor = window.G.utils.RenderUtil.color2Object(fillColorTem);
                // option.opacity = 1;
                // if (symbol.lineStyle=='dashed'){
                //     option.style=0;
                // }else{
                //     option.style = parseInt(symbol.lineStyle);
                // }
                option.style = parseInt(symbol.lineStyle, 10);
                symbolColor.options = option;
            } else if (type === 'SimpleLineSymbol') {
                const option: any = {};
                symbolColor.type = type;
                option.width = symbol.linewidth;
                const lineColorTem = this._hex2ColorObj(symbol.borderColor);
                lineColorTem.a = parseInt(symbol.iconOpacity, 10);
                option.color = window.G.utils.RenderUtil.color2Object(lineColorTem);
                option.style = parseInt(symbol.lineStyle, 10);
                // if (symbol.lineStyle=='dashed'){
                //     option.style=0;
                // }else{
                //     option.style = parseInt(symbol.lineStyle);
                // }
                // option.opacity = parseInt(symbol.iconOpacity)/255;
                symbolColor.options = option;
            } else if (type === 'TextSymbol') {
                const option: any = {};
                symbolColor.type = type;
                option.text = Util.addTextLineSeperator(symbol.inputFont.toString(), this.opt.textLineLimit);
                option.fontSize = parseInt(symbol.fontSizeLi, 10);
                const foregroundTem = this._hex2ColorObj(symbol.textColor);
                option.foreground = window.G.utils.RenderUtil.color2Object(foregroundTem);
                option.fontFamilyName = symbol.fontFamilyLi;
                option.textAlign = 'center';
                option.rotation = 0;
                option.borderColor = { alpha: 1, r: 255, g: 255, b: 255 };
                option.borderThickness = 0;
                symbolColor.options = option;
            } else if (type === 'TailedText') {
                // const option: any = { domStyle: {}, symbol: {} };
                // option.domStyle.background = symbol.fillColor;
                // option.domStyle.border = symbol.borderWidth + 'px solid ' + symbol.borderColor;
                // option.domStyle.fontFamily = symbol.fontFamilyLi;
                // option.domStyle.fontSize = symbol.fontSizeLi;
                // option.domStyle.color = symbol.textColor;
                // option.domStyle['font-size'] = symbol.fontFamilyLi + 'px';
                // option.domStyle.opacity = symbol.iconOpacity / 255;
                // option.domHtml = symbol.inputFont.toString();
                const option: any = {};
                option.backgroundColor = this._hex2ColorObj(symbol.fillColor);
                option.textBackgroundBorderThickness = parseInt(symbol.borderWidth, 10);
                option.textBackgroundBorderColor = this._hex2ColorObj(symbol.borderColor);
                option.fontFamilyName = symbol.fontFamilyLi;
                option.fontSize = symbol.fontSizeLi;
                option.foregroundColor = this._hex2ColorObj(symbol.textColor);
                option.opacity = symbol.iconOpacity;
                option.label = symbol.inputFont.toString();
                option.lineWidth = parseInt(symbol.linewidth, 10);
                option.lineColor = this._hex2ColorObj(symbol.lineColor);
                option.padding = option.padding;
                // option.padding = [padding, padding, padding, padding];
                // option.padding = [10, 10, 10, 10];
                // const lineColorTem = this._hex2ColorObj(symbol.lineColor);
                // option.symbol = {
                //     type: 'SimpleLineSymbol',
                //     options: {
                //         color: {
                //             alpha: 200,
                //             r: lineColorTem.r,
                //             g: lineColorTem.g,
                //             b: lineColorTem.b,
                //         },
                //         style: '5',
                //         width: parseInt(symbol.linewidth, 10),
                //     },
                // },
                // const lineColorTem = this._hex2ColorObj(symbol.lineColor);
                // option.symbol = {
                //     type: 'SimpleLineSymbol',
                //     options: {
                //         color: {
                //             alpha: 200,
                //             r: lineColorTem.r,
                //             g: lineColorTem.g,
                //             b: lineColorTem.b,
                //         },
                //         style: '5',
                //         width: parseInt(symbol.linewidth, 10),
                //     },
                // },
                    // .color = lineColorTem;//G.utils.RenderUtil.color2Object(lineColorTem);
                    // option.symbol.width = parseInt(symbol.linewidth);
                symbolColor.options = option;
            } else if (type === 'VectorMarkerSymbol' || type === 'PictureMarkerSymbol') {
                const options: any = {
                    type: 'VectorMarkerSymbol',
                    options: symbol.options,
                };
                options.options.opacity = symbol.iconOpacity / 255;
                options.options.scale = symbol.scale;
                symbolColor = options;
            }
            self.PlotComponent.updatePlotElement({
                id: plotId,
                symbol: symbolColor,
                plotProperty: descStr,
            });
        } else {
            window.G.utils.LoggerUtil.warn('当前无选择的标绘！');
        }
    }

    /**
     * 切换未保存的标绘的显示
     * @method
     * @param id {String} - 必填，元素id
     * @param visible {Boolean} - 必填，是否显示
     */
    public toggleUnsavedPlot(id: any, visible: any) {
        const self = this;
        const ele = self.PlotComponent.getPlotElementById(id);
        if (ele) {

            self.plotLayer.showElement(ele, visible);
            if (ele.kind === 'tailedtext') {
                self.PlotComponent.toggleElement(id, visible);
            }
            if (visible) {
                const center = ele.plot.centerPoint;
                self.options.map.setCenter(center);
            }
        }
    }

    // 清除地图显示的结果点
    public clearResults() {
        if (this.layer) {
            this.layer.clear();
        }
        if (this.toolTipWare) {
            this.toolTipWare.clear();
        }
    }

    // 移除Control
    public removeControl() {
        this.clearResults();
        if (this.layer) {
            this.options.map.removeLayer(this.layer);
        }

    }


    /**
     * 绑定地图元素点击回调
     * @method
     * @param data
     * @param data.id {String} - 必填，元素id
     * @param data.symbol {Object} - 必填，样式符号
     */
    public firePlotClickEvent(data: any) {
        if (data.symbol &&
            (data.symbol.type === 'TextSymbol' || data.symbol.type === 'TailedText')) {
            data.symbol.inputFont = Util.removeTextLineSeperator(data.symbol.inputFont);
        }
        this.fire('plotElementClick', data);
    }

    /**
     * 绑定地图点击空白回调
     * @method
     * @param data
     */
    public fireClearEditPanelEvent() {
        this.fire('clearEditPanel');
    }

    /**
     * 白板标绘切换回调
     * @method
     */
    public fireWhiteBoardChangeEvent() {
        this.fire('whiteBoardChange');
    }

    /**
     * 标绘方案列表回调
     * @method
     * @param data
     * @param data.data {Array} - 必填，标绘方案id和name对象数组
     */
    public fireRefreshSchemaListEvent(data: any) {
        this.fire('refreshSchemaList', data);
    }

    /**
     * 标绘方案详细元素信息列表回调
     * @method
     * @param data
     * @param data.data {Array} - 必填，标绘方案详细元素id和name对象数组
     */
    public firePlanEleListEvent(data: any) {
        this.fire('planEleList', data);
    }

    /**
     * 标绘方案检索回调
     * @method
     * @param data
     * @param data.data {Array} - 必填，标绘方案id和name对象数组
     */
    public firePlanSearchBackEvent(data: any) {

        this.fire('planSearchBack', data);
    }

    /**
     * 更新未保存的标绘
     * @method
     * @param data
     * @param data.data {Array} - 必填，标绘元素id和content名称对象数组
     */
    public fireUpdateUnsavedViewEvent(data: any) {
        this.fire('updateUnsavedView', data);
    }

    /**
     * 查询标绘常用和工具箱数据
     * @method
     * @param data
     * @param data.common {Object} - 必填，常用标绘数据
     * @param data.normal {Object} - 必填，标绘工具箱数据
     */
    public firePlotDataQueryEvent(data: any) {
        this.fire('plotDataQuery', data);
    }

    /**
     * 标绘方案列表回调
     * @method
     * @param data
     * @param data.data {Array} - 必填，标绘方案id和name对象数组
     */
    public fireUpdataPlotSchemaListEvent(data: any) {
        this.fire('updataPlotSchemaList', data);
    }

    private _color2Hex(obj: any) {
        let color: string = '';
        obj.r = obj.r || 0;
        color += obj.r.toString(16).toUpperCase();
        if (color.length === 1) {
            color += '0';
        }
        obj.g = obj.g || 0;
        color += obj.g.toString(16).toUpperCase();
        if (color.length === 3) {
            color += '0';
        }
        obj.b = obj.b || 0;
        color += obj.b.toString(16).toUpperCase();
        if (color.length === 5) {
            color += '0';
        }
        return '#' + color;
    }

    private _hex2ColorObj(colorHex: string) {
        const str: string = colorHex.substr(1);
        const opts: any = {
            a: 255,
            r: 0,
            g: 0,
            b: 0,
        };
        if (str.length === 3) {
            opts.r = parseInt(str[0] + str[0], 16);
            opts.g = parseInt(str[1] + str[1], 16);
            opts.b = parseInt(str[2] + str[2], 16);
        } else {
            opts.r = parseInt(str[0] + str[1], 16);
            opts.g = parseInt(str[2] + str[3], 16);
            opts.b = parseInt(str[4] + str[5], 16);
        }
        return new (g2 as any).sfs.Color(opts);
    }
}




